import { Router } from "@shared/routes/Router";

export function App() {
	return <Router />;
}
